import { defineStore } from 'pinia';
import { reactive, ref, computed } from 'vue';
import type { IMenuCategoriesApiResponse, IMenuCategoriesItem, IProductCategoriesItem } from '~/modules/menu/types/menu';

export const useMenuCategoriesStore = defineStore('menuCategoriesStore', () => {
  const categoriesList = reactive<IMenuCategoriesItem[]>([]);
  const activeCategoriesListID = ref<number | null>(null);
  const activeSecondaryItemID = ref<number | null>(null);
  const productCategoriesList = reactive<IProductCategoriesItem[]>([]);

  const rewriteMenuList = (data: IMenuCategoriesApiResponse) => {
    categoriesList.splice(0, categoriesList.length, ...data.items);
  };

  const rewriteProductCategoriesList = (data: IProductCategoriesItem[]) => {
    productCategoriesList.splice(0, productCategoriesList.length, ...data);
  };

  const setActiveCategoriesListID = (id: number | null) => {
    activeCategoriesListID.value = id;
  };

  const setActiveSecondaryItemID = (id: number | null) => {
    activeSecondaryItemID.value = id;
  };

  const resetActiveCategoriesListID = () => setActiveCategoriesListID(categoriesList[0]?.id || null);

  const getProductCategoryById = (id: number) => {
    return productCategoriesList.find((c) => c.id === id);
  };

  return {
    categoriesList,
    activeCategoriesListID,
    activeSecondaryItemID,
    rewriteMenuList,
    rewriteProductCategoriesList,
    setActiveCategoriesListID,
    setActiveSecondaryItemID,
    resetActiveCategoriesListID,
    getProductCategoryById,
    productCategoriesList,
  };
});
